<template>
  <div class="filterbar" id="filterbar" :style="{ top: top + 'px' }">
    <div class="container">
      <div class="row">
        <div
          class="col"
          :class="{ selected: index == selectedIndexMenu }"
          :key="index"
          @click="handleShowDialog(barMenu, index)"
          v-for="(barMenu, index) in barMenus"
        >
          {{ barMenu.name }}<span :class="index == selectedIndexMenu ? barMenu.selectIcon : barMenu.defaultIcon"></span>
        </div>
      </div>
      <filter-bar-pop
        ref="fbp"
        :scrollLength="scrollLength"
        :filterTop="top"
        :show-dialog="isShow"
        :hasTabHeader="hasTabHeader"
        :menu="selectedMenu"
        @changeTab="handleChangeTab"
        @changeMainItem="handleChangeMainItem"
        @changeSelect="changeSelect"
        @closeDialog1="handleCloseDialog"
        @closeDialog="handleCloseDialog"
      ></filter-bar-pop>
    </div>
  </div>
</template>
<script>
import FilterBarPop from './FilterBarPop'
import { setTimeout } from 'timers'

export default {
  props: {
    barMenus: {
      type: Array,
      required: true,
      validator: function (value) {
        //TODO:验证数据有效性
        return true
      }
    },
    filterType: String,
    top: String
  },
  data() {
    return {
      conditionSelect: {},
      thisTabSelect: {},
      isShow: false,
      hasTabHeader: false,
      selectedMenu: {},
      selectedIndexMenu: undefined,
      scrollLength: 0
    }
  },
  methods: {
    handleShowDialog(menu, index) {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrollLength = scrollTop
      this.thisTabSelect = menu
      if (this.selectedIndexMenu != index || this.selectedIndexMenu == undefined) {
        if (this.selectedIndexMenu != index && this.selectedIndexMenu != undefined) {
          this.$refs.fbp.clearnRange()
        }
        // 阻止微信页面滑动
        document.querySelector('body').style.position = 'fixed'

        // 筛选条定位 secondHandHouse
        if (document.getElementById('sHH')) {
          this.$parent.pageStopScroll()
        }

        this.isShow = true
        this.selectedMenu = menu
        this.selectedIndexMenu = index
        if (menu.showTabHeader) {
          this.hasTabHeader = true
        } else {
          this.hasTabHeader = false
        }
        let _menu = JSON.parse(JSON.stringify(menu))
        _menu.tabs = {}
        this.$emit('showDialog', _menu)

        //secondHandHouse
        if (!document.querySelector('.main')) {
        } else {
          this.theWindowTop = document.querySelector('.main').offsetHeight
        }
      } else if (this.selectedIndexMenu == index) {
        this.$refs.fbp.closeDialog1()
      }
    },
    handleChangeTab(tab) {
      this.$emit('changeTab', tab.index)
    },
    handleChangeMainItem(mainItem) {
      let _mainItem = JSON.parse(JSON.stringify(mainItem))
      this.$emit('changeMainItem', _mainItem)
    },
    handleCloseDialog() {
      this.isShow = false
      this.selectedIndexMenu = -1
      this.$emit('closeDialog')
    },
    //选中值
    changeSelect() {
      var selectData = []
      this.barMenus.forEach(function (barMenu, index, arr) {
        let _selectBarData = {}

        _selectBarData.name = barMenu.name
        _selectBarData.value = barMenu.value
        _selectBarData.tab = {}
        let tab = barMenu.tabs[barMenu.selectIndex]

        _selectBarData.tab.name = tab.name
        _selectBarData.tab.value = tab.value
        let mainItem = tab.detailList[tab.selectIndex]
        _selectBarData.tab.mainItem = {}

        _selectBarData.tab.mainItem.name = mainItem.name
        _selectBarData.tab.mainItem.value = mainItem.vaule
        let subItem = false
        if (mainItem.list) {
          subItem = mainItem.list[mainItem.selectIndex]
          _selectBarData.tab.mainItem.subItem = {}

          _selectBarData.tab.mainItem.subItem.name = subItem.name
          _selectBarData.tab.mainItem.subItem.value = subItem.value
        } else {
          _selectBarData.tab.mainItem.subItem = subItem
        }

        selectData.push(_selectBarData)
      })
      this.conditionSelect = selectData
      this.$emit('changeSelect', selectData)
    }
  },
  components: {
    'filter-bar-pop': FilterBarPop
  }
}
</script>
<style lang="less">
.filterbar {
  width: 750px;
  background: #fff;
  height: 100px;
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  .container {
    width: 100%;
    height: 100px;
    // outline: 1px solid #e4e4e4;
    border-bottom: 1px solid #e4e4e4;

    .row {
      display: flex;
      display: -ms-flexbox;
      display: -moz-box;
      display: -webkit-box;
      display: -webkit-flex;
      flex-direction: row;
      -webkit-flex-direction: row;
      justify-content: space-around;
      -webkit-box-pack: space-around;
      -moz-box-pack: space-around;
      -ms-flex-pack: space-around;
      width: 100%;
      height: 100px;
      margin: 0 auto;
      line-height: 40px;
      position: absolute;
      z-index: 999;
      background: #fff;
      border-bottom: 1px solid #e4e4e4;
      .selected {
        color: #338cfd !important;
        span {
          background-image: url(../../static/images/sHH/drawable-xhdpi/icon_shouqi.png) !important;
        }
      }
      .col {
        height: 100px;
        line-height: 100px;
        font-size: 30px;
        color: #333;
        span {
          margin-left: 15px;
          vertical-align: middle;
          background-image: url(../../static/images/sHH/drawable-xhdpi/icon_xiala.png);
          background-size: 100%;
          background-repeat: no-repeat;
          background-position: center;
          width: 14px;
          height: 14px;
          display: inline-block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FilterBar.vue